import { render } from "./StatusTd.vue?vue&type=template&id=bb28e25a"
import script from "./StatusTd.vue?vue&type=script&lang=js"
export * from "./StatusTd.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__